import { Stack, Surface, Text } from "@app/ui"
import type { CSSProperties } from "react"

/**
 * Shown to non-admin users (i.e. anyone who is not the inviting
 * admin) when first-run onboarding is still incomplete. The
 * dashboard cannot yet show meaningful data so we politely block
 * the route tree until the admin finishes the wizard.
 */
const WRAPPER_STYLE: CSSProperties = {
	minHeight: "60vh",
	padding: 48,
}

export function OnboardingLockedScreen() {
	return (
		<Stack align="center" justify="center" gap="0" style={WRAPPER_STYLE}>
			<Surface elevation="1" tone="muted" bordered>
				<Stack gap="3" align="center" style={{ padding: 32, maxWidth: 480 }}>
					<Text variant="display-sm">Setup in progress</Text>
					<Text variant="body-md" tone="muted">
						The admin needs to finish first-run setup before the dashboard becomes available. Ask
						your admin to complete the onboarding wizard.
					</Text>
				</Stack>
			</Surface>
		</Stack>
	)
}
